/**
 * Player error messages that are known to occur without indicating an actual
 * playback problem worth surfacing to regular users. These are hidden from regular users
 */
const KNOWN_NON_FATAL_ERROR_PATTERNS = [
  'Failed to seek to position',
  'preload called while another operation was on-going',
];

export function isKnownNonFatalError(message: string): boolean {
  return KNOWN_NON_FATAL_ERROR_PATTERNS.some(pattern => message.includes(pattern));
}
